<template>
  <div id="PlayContentRankingWrap">
    <div class="hd-title">
      <p class="title">播放内容排名</p>
    </div>
    <div class="PlayContentRanking__content">
      <div class="lists-wrap">
        <div class="item" v-for="(item,index) in lists" :key="index">
          <span class="count-icon" :class="[`count-icon-${index+1}`]">{{ index+1 }}</span>
          <span class="name">{{ item.name }}</span>
          <span class="count">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayContentRankingWrap',
  props: {
    lists: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.hd-title
   .title
      margin 1rem 0
      font-size .9rem
.lists-wrap
   display flex
   flex-direction column
   height 8rem
   flex-wrap: wrap
   .item
      font-size: .8rem
      display flex
      width 12.1rem
      margin-bottom .75rem
   .count-icon
      font-size: .5rem
      display: inline-block
      width .8rem
      height .8rem
      border-radius: 20%
      text-align center
      line-height: .8rem
      background-color: rgba(255, 255, 255, 0.3)
      margin-right: .8rem
      flex-shrink: 0
   .name
      color: rgba(255, 255, 255, 0.8);
      flex-grow: 1
      white-space nowrap
      overflow hidden
      text-overflow: ellipsis
   .count-icon-1
      background-color: #FF2C83
   .count-icon-2
      background-color: #FF862B
   .count-icon-3
      background-color: #E8BC00
</style>
